import {createStore, applyMiddleware} from 'redux';
//bringing in redux-persist to save our redux store on local storage
import {persistStore} from 'redux-persist';
import logger from 'redux-logger';
// import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './root-reducer';

import rootSaga from './root.saga';

// const middlewares = [thunk];
const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];
if(process.env.NODE_ENV==='development'){
    middlewares.push(logger);
}
export const store = createStore(rootReducer, applyMiddleware(...middlewares));

sagaMiddleware.run(rootSaga);


export const persistor = persistStore(store);


export default {store, persistor};